import React from 'react';
import DashboardButton from './DashboardButton';
import loadingIcon from '/src/assets/images/button/loading-circle-2.svg?url';

const ButtonPending: React.FC = () => (
  <DashboardButton
    badge
    label="درحال بررسی"
    width={100}
    height={28}
    backgroundColor="transparent"
    textColor="#059669"
    startIcon={
      <img
        src={loadingIcon}
        alt="loading Icon"
        style={{ width: '20px', height: '20px' }}
      />
    }
  />
);

export default ButtonPending;
